<div *ngIf="currentUser" id="sidebar">
  <ng-container *notAllowedPermissions="['mustSetupAuthenticator']">
    <div class="nav-list">
      <nav class="navbar navbar-default" role="navigation">
        <div class="nav navbar-header navbar-nav sidebar-header">
          <span class="company-name">{{ currentUser.company?.name | uppercase }}</span>
          <span class="sidebar-toggle-inline">
            <button type="button" class="toggle-button" (click)="expandAll()">Expand menu</button>
            <button type="button" class="toggle-button" (click)="collapseAll()">Collapse menu</button>
          </span>
        </div>
        <ul class="nav navbar-nav">
          <li *roles="['ROLE_MCKAY']">
            <a [routerLinkActiveOptions]="{exact: true}"
               routerLink="/mckay/{{currentUser.company.uniqid}}"
                routerLinkActive="active">Home</a>
          </li>
          <li *roles="['ROLE_CLIENT']">
            <a [routerLinkActiveOptions]="{exact: true}"
            routerLink="/client/{{currentUser.company.uniqid}}"
            routerLinkActive="active">Home</a>
          </li>
          <div class="sidebar-section" *permission="['canSeeDownloadsSection']">
            <li><hr></li>
            <li class="sidebar-section-header icon"
                role="button"
                tabindex="0"
                (click)="toggleSection('documents')"
                (keyup)="onSectionHeaderKeydown($event, 'documents')"
                [attr.aria-expanded]="!isCollapsed('documents')">
              <span><i class="fa fa-book"></i> {{ menuSections.DOCUMENTS }}</span>
              <i class="fa fa-chevron-down toggle-icon" [class.collapsed]="isCollapsed('documents')"></i>
            </li>
            <div class="sidebar-section-content" [class.collapsed]="isCollapsed('documents')">
              <li *permission="['canAccessCommercialPops']">
                <a [routerLinkActiveOptions]="{exact: true}"
                routerLink="/commercial-pop"
                routerLinkActive="active">Commercial PoPs</a>
              </li>
              <li *permission="['canAccessAnnouncementLog']">
                <a routerLink="/{{currentUser.company.uniqid}}/announcementLog"
                routerLinkActive="active">Announcement history</a>
              </li>
              <li *permission="['canAccessDownloads']">
                <a routerLink="/document"
                routerLinkActive="active">Downloads</a>
              </li>
              <li *roles="['ROLE_MCKAY_SUPER','ROLE_MCKAY_ADMIN']">
                <a routerLink="/emergency-announcement"
                   routerLinkActive="active">Emergency Announcement</a>
              </li>
            </div>
          </div>
          <div class="sidebar-section" *roles="['ROLE_MCKAY']">
            <li><hr></li>
            <li class="sidebar-section-header icon"
                role="button"
                tabindex="0"
                (click)="toggleSection('clients')"
                (keyup)="onSectionHeaderKeydown($event, 'clients')"
                [attr.aria-expanded]="!isCollapsed('clients')">
                <span><i class="fa fa-address-book"></i> {{ menuSections.CLIENTS }}</span>
              <i class="fa fa-chevron-down toggle-icon" [class.collapsed]="isCollapsed('clients')"></i>
            </li>
            <div class="sidebar-section-content" [class.collapsed]="isCollapsed('clients')">
              <li>
                <a routerLink="/{{currentUser.company.uniqid}}/company"
                   routerLinkActive="active">List companies</a>
              </li>
              <li>
                <a *roles="['ROLE_MCKAY_SUPER','ROLE_MCKAY_ADMIN']"
                   routerLink="/impersonate-user"
                   routerLinkActive="active">Impersonate User</a>
              </li>
            </div>
          </div>
          <div class="sidebar-section" *roles="['ROLE_MCKAY']">
            <li><hr></li>
            <li class="sidebar-section-header icon"
                role="button"
                tabindex="0"
                (click)="toggleSection('portal_admin')"
                (keyup)="onSectionHeaderKeydown($event, 'portal_admin')"
                [attr.aria-expanded]="!isCollapsed('portal_admin')">
              <span><i class="fa fa-bolt"></i> {{ menuSections.PORTAL_ADMIN }}</span>
              <i class="fa fa-chevron-down toggle-icon" [class.collapsed]="isCollapsed('portal_admin')"></i>
            </li>
            <div class="sidebar-section-content" [class.collapsed]="isCollapsed('portal_admin')">
              <li *permission="['canAccessHistoricalDataLog']">
                <a routerLink="/historical-data-log"
                   routerLinkActive="active">Historical BW-service data request log</a>
              </li>
              <li *permission="['canAccessDownloadsLog']">
                <a routerLink="/{{currentUser.company.uniqid}}/download-log"
                   routerLinkActive="active">Download log</a>
              </li>
              <li *permission="['canAccessSymbolDataDownloadLog']">
                <a routerLink="/{{currentUser.company.uniqid}}/symbolDataDownloadLog"
                   routerLinkActive="active"> Symbol data download log</a>
              </li>
            </div>
          </div>
          <div class="sidebar-section" *permission="['canSeeUsersSection']">
            <li><hr></li>
            <li class="navbar-left icon sidebar-section-header"
                role="button"
                tabindex="0"
                (click)="toggleSection('users')"
                (keyup)="onSectionHeaderKeydown($event, 'users')"
                [attr.aria-expanded]="!isCollapsed('users')">
              <span><i class="fa fa-users"></i> {{ menuSections.USERS }}</span>
              <i class="fa fa-chevron-down toggle-icon" [class.collapsed]="isCollapsed('users')"></i>
            </li>
            <div class="sidebar-section-content" [class.collapsed]="isCollapsed('users')">
              <li *permission="['canEditYours']" class="navbar-left">
                <a [routerLinkActiveOptions]="{exact: true}"
                   routerLink="/{{currentUser.company.uniqid}}/{{currentUser.company.uniqid}}/{{currentUser.uniqid}}/edit"
                   routerLinkActive="active">Edit my contact info</a>
              </li>
              <li *permission="['canListUsers']">
                <a routerLink="/{{currentUser.company.uniqid}}/{{currentUser.company.uniqid}}/users"
                   routerLinkActive="active">List {{ currentUser.company.name }} users</a>
              </li>
              <ng-container *roles="['ROLE_CLIENT']">
                <li *permission="['canManageInvoiceRecipients']">
                  <a routerLink="/{{currentUser.company.uniqid}}/manage-inv-recipient"
                     routerLinkActive="active">Manage invoice recipients</a>
                </li>
              </ng-container>
              <li *permission="['canAccessAuditTrail']">
                <a routerLink="/audit-trail" routerLinkActive="active">Audit trail</a>
              </li>
            </div>
          </div>
          <div class="sidebar-section" *permission="['canAccessLoas', 'canAccessWorkVisit']">
            <li><hr></li>
            <li class="navbar-left icon sidebar-section-header"
                role="button"
                tabindex="0"
                (click)="toggleSection('crossConnects')"
                (keyup)="onSectionHeaderKeydown($event, 'crossConnects')"
                [attr.aria-expanded]="!isCollapsed('crossConnects')">
              <span><i class="fa fa-server"></i> {{ menuSections.XCO }}</span>
              <i class="fa fa-chevron-down toggle-icon" [class.collapsed]="isCollapsed('crossConnects')"></i>
            </li>
            <div class="sidebar-section-content" [class.collapsed]="isCollapsed('crossConnects')">
              <li *permission="['canAccessLoas']">
                <a routerLink="/loa"
                   routerLinkActive="active">LOAs</a>
              </li>
              <li *permission="['canAccessWorkVisit']">
                <a routerLink="/hosting"
                   routerLinkActive="active">Hosting - Datacenter work visits</a>
              </li>
              <li *permission="['canAccessCommercialPops']">
                <a routerLink="/service-delivery-locations"
                   routerLinkActive="active">Service delivery locations</a>
              </li>
              <ng-container *roles="['ROLE_CLIENT', 'ROLE_MCKAY_SUPER', 'ROLE_MCKAY_ADMIN']">
                <li *permission="['canAccessCommercialPops']">
                  <a routerLink="/market-data-ledgers"
                     routerLinkActive="active">Ledger of Additional Data Distribution Points</a>
                </li>
              </ng-container>
            </div>
          </div>
          <div class="sidebar-section" *permission="['canSeeBandwidthSection']">
            <li><hr></li>
            <li class="navbar-left icon sidebar-section-header"
                role="button"
                tabindex="0"
                (click)="toggleSection('bandwidth')"
                (keyup)="onSectionHeaderKeydown($event, 'bandwidth')"
                [attr.aria-expanded]="!isCollapsed('bandwidth')">
              <span><i class="fa fa-signal"></i> {{ menuSections.BW }}</span>
              <i class="fa fa-chevron-down toggle-icon" [class.collapsed]="isCollapsed('bandwidth')"></i>
            </li>
            <div class="sidebar-section-content" [class.collapsed]="isCollapsed('bandwidth')">
              <li *permission="['canListSchedules']" [class.active]="isSchedulesLinkActive()">
                <a routerLink="/schedules"
                   [class.active]="isSchedulesLinkActive()">List Bandwidth Schedules</a>
              </li>
              <li *permission="['canListSchedules']">
                <a [routerLinkActiveOptions]="{exact: true}"
                   routerLink="/bandwidth-graphs"
                   routerLinkActive="active">Bandwidth end-to-end graphs</a>
              </li>
              <li *permission="['canAccessHistoricalData']">
                <a routerLink="/{{currentUser.company.uniqid}}/history-request"
                   routerLinkActive="active">Request PLR/lat historical data</a>
              </li>
          <!--<li *permission="['canAccessAwsPage']">
                <a routerLink="/connections-counters-live"
                   routerLinkActive="active"
                   [routerLinkActiveOptions]="{exact: true}">Network port statistics</a>
              </li>-->
              <li *permission="['canAccessAwsPage']">
                <a [routerLinkActiveOptions]="{exact: true}"
                   routerLink="/etrees-counters-live"
                   routerLinkActive="active">Network E-Trees statistics</a>
              </li>
              <li *permission="['canActivateMqttCounters']">
                <a [routerLinkActiveOptions]="{exact: true}"
                   routerLink="/counters-mqtt"
                   routerLinkActive="active">Network counters through MQTT</a>
              </li>
              <li *permission="['isMckayAdminOrMckaySuper']">
                <a routerLink="/bandwidth-monitoring"
                   routerLinkActive="active">BW Monitoring strategies</a>
              </li>
              <li *permission="['canListQuincyEtrees']">
                <a routerLink="/quincy-etrees"
                   routerLinkActive="active">List Quincy E-Trees</a>
              </li>
              <li *permission="['canAccessEtreeLedger']">
                <a routerLink="/clf-ledger"
                   routerLinkActive="active">Ledger of Local Fiber E-Trees</a>
              </li>
              <li *permission="['canAccessCryptoMonitoring']">
                <a [routerLinkActiveOptions]="{exact: true}"
                   routerLink="/crypto-monitoring"
                   routerLinkActive="active">Crypto service monitoring</a>
              </li>
            </div>
          </div>
          <div class="sidebar-section sidebar-market-data" *permission="['canSeeMarketDataSection']">
            <li><hr></li>
            <li class="navbar-left icon sidebar-section-header"
                role="button"
                tabindex="0"
                (click)="toggleSection('marketData')"
                (keyup)="onSectionHeaderKeydown($event, 'marketData')"
                [attr.aria-expanded]="!isCollapsed('marketData')">
              <span><i class="fa fa-bar-chart"></i> {{ menuSections.MD }}</span>
              <i class="fa fa-chevron-down toggle-icon" [class.collapsed]="isCollapsed('marketData')"></i>
            </li>
            <div class="sidebar-section-content"  [class.collapsed]="isCollapsed('marketData')">
              <li *permission="['canAccessEncryptionKeys']">
                <a [routerLinkActiveOptions]="{exact: true}"
                   routerLink="/encryption-keys"
                   routerLinkActive="active">Encryption Keys</a>
              </li>
              <div *permission="['canAccessDad']" class="sidebar-subsection">
                <div class="sidebar-subtitle">Data access declaration</div>
                <li *permission="['canAccessDad']" class="navbar-left">
                  <a routerLink="/dad-admin"
                     routerLinkActive="active">DAD Admin</a>
                </li>
                <li *roles="['ROLE_MCKAY_SUPER', 'ROLE_MCKAY_ADMIN', 'ROLE_MCKAY_DAD_REPORTER']" class="navbar-left">
                  <a routerLink="/exchanges"
                     routerLinkActive="active">List Exchanges</a>
                </li>
                <li *roles="['ROLE_MCKAY_SUPER']">
                  <a routerLink="/reporters"
                     routerLinkActive="active">List Reporters</a>
                </li>
              </div>
              <div *permission="['canSeeQedSection']" class="sidebar-subsection">
                <div class="sidebar-subtitle">Snapshot (QED)</div>
                <ng-container *roles="['ROLE_CLIENT']">
                  <li *permission="['canAccessQedProfile']" class="navbar-left">
                    <a routerLink="/{{currentUser.company.uniqid}}/quincyClientProfile/qed"
                       routerLinkActive="active">Profile</a>
                  </li>
                </ng-container>
                <li *permission="['canAccessPlrLatencyGraphs']" class="navbar-left">
                  <a routerLink="/market-data-plr-latency"
                     routerLinkActive="active">PLR&Lat graphs</a>
                </li>
                <li *permission="['canAccessAdminEncryptionKeys']" class="navbar-left">
                  <a routerLink="/{{currentUser.company.uniqid}}/encryption-keys"
                     routerLinkActive="active">Encryption keys summary</a></li>
                <li *permission="['canAccessEncryptionKeysLogs']">
                  <a [routerLinkActiveOptions]="{exact: true}"
                     routerLink="/encryption-keys-logs"
                     routerLinkActive="active">Encryption Keys Logs</a>
                </li>
                <li *permission="['canAccessSymbolsMulticast']" class="navbar-left">
                  <a [routerLinkActiveOptions]="{exact: true}"
                     routerLink="/qed-symbols"
                     routerLinkActive="active">Symbols</a>
                </li>
                <li *permission="['canAccessSymbolsMulticast']" class="navbar-left">
                  <a routerLink="/qed-symbols/multicast"
                     routerLinkActive="active">Multicasts</a>
                </li>
              </div>
              <div *permission="['canSeeQhfSection']" class="sidebar-subsection">
                <div class="sidebar-subtitle">Volume Signals (QHF)</div>
                <ng-container *roles="['ROLE_CLIENT']">
                  <li *permission="['canAccessQhfProfile']" class="navbar-left">
                    <a routerLink="/{{currentUser.company.uniqid}}/quincyClientProfile/qhf"
                       routerLinkActive="active">Profile</a>
                  </li>
                </ng-container>
                <li *permission="['canAccessQhfPlrLatencyGraphs']" >
                  <a routerLink="market-data-qhf-plr-latency-graph"
                     routerLinkActive="active">PLR&Lat graphs</a>
                </li>
                <li class="navbar-left" *permission="['canAccessSymbolsMulticast']">
                  <a [routerLinkActiveOptions]="{exact: true}"
                     routerLink="/qhf-symbols"
                     routerLinkActive="active">Symbols</a>
                </li>
                <li class="navbar-left" *permission="['canAccessSymbolsMulticast']">
                  <a routerLink="/qhf-symbols/multicast"
                     routerLinkActive="active">Multicasts</a>
                </li>
              </div>
              <div *permission="['canSeeQrdSection']" class="sidebar-subsection">
                <div class="sidebar-subtitle">Raw (QRD/QPD)</div>
                <ng-container *roles="['ROLE_CLIENT']">
                  <li *permission="['canAccessQrdProfile']" class="navbar-left">
                    <a routerLink="/{{currentUser.company.uniqid}}/quincyClientProfile/qrd"
                       routerLinkActive="active">Profile</a>
                  </li>
                </ng-container>
                <li *permission="['canAccessQrdMlrLatencyGraphs']" class="navbar-left">
                  <a routerLink="/market-data-qrd-mlr-latency"
                     routerLinkActive="active">MLR&Lat graphs</a>
                </li>
                <li *permission="['canAccessProductInformation']" class="navbar-left">
                  <a routerLink="/{{currentUser.company.uniqid}}/qrd-products"
                     routerLinkActive="active">Products information</a>
                </li>
                <li *permission="['canAccessSymbolsMulticast']" class="navbar-left">
                  <a [routerLinkActiveOptions]="{exact: true}"
                     routerLink="/qrd-symbols"
                     routerLinkActive="active">Symbols</a>
                </li>
                <li *permission="['canAccessSymbolsMulticast']" class="navbar-left">
                  <a routerLink="/qrd-symbols/multicast"
                     routerLinkActive="active">Multicasts</a>
                </li>
              </div>
              <div *permission="['canAccessNewsProfile']" class="sidebar-subsection">
                <div class="sidebar-subtitle">Quincy News</div>
                <ng-container *roles="['ROLE_CLIENT']">
                  <li *permission="['canAccessNewsProfile']" class="navbar-left">
                    <a routerLink="/{{currentUser.company.uniqid}}/quincyClientProfile/news"
                       routerLinkActive="active">Client profile</a>
                  </li>
                </ng-container>
                <li *permission="['canAccessNewsProfile']" class="navbar-left">
                  <a [routerLinkActiveOptions]="{exact: true}"
                     routerLink="/quincy-news-symbols"
                     routerLinkActive="active">Symbols</a>
                </li>
                <li *permission="['canAccessNewsProfile']" class="navbar-left">
                  <a routerLink="/quincy-news-symbols/multicast"
                     routerLinkActive="active">Multicasts</a>
                </li>
              </div>
              <div *permission="['canSeeQfdSection']" class="sidebar-subsection">
                <div class="sidebar-subtitle">Price&Volume Signals (QFD)</div>
                <ng-container *roles="['ROLE_CLIENT']">
                  <li *permission="['canAccessQfdProfile']" class="navbar-left">
                    <a routerLink="/{{currentUser.company.uniqid}}/quincyClientProfile/qfd"
                       routerLinkActive="active">Profile</a>
                  </li>
                </ng-container>
                <li *permission="['canAccessQfdMlrLatencyGraphs']" class="navbar-left">
                  <a routerLink="/market-data-qfd-mlr-latency"
                     routerLinkActive="active">PLR&Lat graphs</a>
                </li>
                <li class="navbar-left" *permission="['canAccessQfdProfile']">
                  <a routerLink="/qfd-symbols"
                     routerLinkActive="active">Symbols</a>
                </li>
              </div>
            </div>
          </div>
          <div class="sidebar-section" *permission="['canAccessTimeSyncSection']">
            <li><hr></li>
            <li class="navbar-left icon sidebar-section-header"
                role="button"
                tabindex="0"
                (click)="toggleSection('PTE')"
                (keyup)="onSectionHeaderKeydown($event, 'PTE')"
                [attr.aria-expanded]="!isCollapsed('PTE')">
              <span><i class="fa fa-clock-o"></i> {{ menuSections.PTE }}</span>
              <i class="fa fa-chevron-down toggle-icon" [class.collapsed]="isCollapsed('PTE')"></i>
            </li>
            <div class="sidebar-section-content" [class.collapsed]="isCollapsed('PTE')">
              <li *permission="['canAccessTimeSyncProfile']">
                <a routerLink="/{{currentUser.company.uniqid}}/timeSyncProfile"
                   routerLinkActive="active">Profile</a>
              </li>
              <li *permission="['canAccessTimeSyncMonitoring']" class="navbar-left">
                <a routerLink="/time-sync-mqtt"
                   routerLinkActive="active">Monitoring through MQTT</a>
              </li>
              <li *permission="['canAccessTimeSyncMonitoring']" class="navbar-left">
                <a routerLink="/time-sync"
                   routerLinkActive="active">Monitoring page</a>
              </li>
            </div>
          </div>
          <div *permission="['canSeeWeatherMapSection']">
            <li><hr></li>
            <li class="navbar-left icon"><i class="fa fa-picture-o"></i> {{ menuSections.TOOLS }}</li>
            <li class="navbar-left">
              <a routerLink="/weather-map/us"
                 routerLinkActive="active">Weather maps</a>
            </li>
          </div>
        </ul>
        <hr>
      </nav>
    </div>
    <div *ngIf="currentUser.lastLogin || currentUser.lastFailedLoginAt || currentUser.changePasswordAt"
         class="nav-list last-login">
      <nav class="navbar navbar-default" role="navigation">
        <ul class="nav navbar-nav">
          <div *ngIf="currentUser.lastLogin">
            <li class="navbar-left"><b>Last login:</b></li>
            <li class="navbar-left">{{ currentUser.lastLogin | date : "MMM dd, y H:mm" }}</li>
          </div>
          <div *ngIf="currentUser.lastFailedLoginAt">
            <li class="navbar-left"><b>Last failed login:</b></li>
            <li class="navbar-left">{{ currentUser.lastFailedLoginAt | date : "MMM dd, y H:mm" }}</li>
          </div>
          <div *ngIf="currentUser.changePasswordAt" class="last-pwd-change">
            <li class="navbar-left"><b>Last password change:</b></li>
            <li class="navbar-left">{{ currentUser.changePasswordAt | date : "MMM dd, y H:mm" }}</li>
          </div>
          <div>
            <li class="navbar-left timezone-info">
              Time displayed in browser timezone
              <br>
              (UTC), except otherwise indicated.
            </li>
          </div>
        </ul>
      </nav>
    </div>
  </ng-container>
</div>
